import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel, roleReq, vendorReq } from "@project-management-system/shared-models";
import { VendorService } from "./vendor.service";
import { VendorDto } from "./vendor.dto";
import { VendorReportDto } from "./vendor-report.dto";

@Controller('vendor')
@ApiTags('/vendor')
export class VendorController {
    constructor(private service: VendorService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/getAllVendors')
    async getAllVendors(): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllVendors();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/createVendor')
    @ApiBody({ type: VendorDto })
    async createVendor(@Body() req: any): Promise<CommonResponseModel> {
        try {
            console.log(req, 'ppppppppppp');

            return await this.service.createVendor(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/getAllVendorRequests')
    @ApiBody({type: VendorReportDto})
    async getAllVendorRequests(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllVendorRequests(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/updateVendor')
    @ApiBody({ type: VendorDto })
    async updateVendor(@Body() req: any): Promise<CommonResponseModel> {
        try {


            return await this.service.updateVendor(req);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateVendor')
    @ApiBody({ type: VendorDto })
    async activateOrDeactivateVendor(@Body() dto: any, isUpdate: boolean = false): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivateVendor(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getActiveAllVendor')
    async getActiveAllVendor(): Promise<CommonResponseModel> {
        try {
            return await this.service.getActiveAllVendor();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }
    @Post('/getAllvendorCoderequest')
    @ApiBody({type: vendorReq})
    async getAllvendorCoderequest(@Body() req?:any): Promise<CommonResponseModel> {
        // console.log(req,'oooooooooo');
        
        try {
            return await this.service.getAllvendorCoderequest(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }
}